
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Label',
  props: {
    label: {
      type: String
    },
    isHorizontal: {
      type: Boolean
    }
  }
});
